export default __webpack_public_path__ + "static/media/timer.e650bd47.svg";